import styled from 'styled-components'

export const ContainerTimeline = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    gap: 15px;

    :is([data-large = true]) {
        gap: 0px;
    }
`;